import React from "react"
import { styled } from "@mui/material/styles"
import logo from "../images/orterycloud.svg"

const LogoImage = styled("img")({
    display: "block",
    maxWidth: "100%",
    height: "auto",
    cursor: "pointer",
})
const InvertLogo = styled("img")({
    display: "block",
    maxWidth: "100%",
    width: 500,
    height: "auto",
    cursor: "pointer",
})
interface ILogoProps {
    invert?: boolean
}

export default function Logo(props: ILogoProps) {
    return props.invert ? (
        <InvertLogo
            onClick={() => (window.location.href = "/")}
            src={logo}
            alt="Ortery Cloud"
        />
    ) : (
        <LogoImage
            onClick={() => (window.location.href = "/")}
            src={logo}
            alt="Ortery Cloud"
        />
    )
}
